module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/dj-console-icon-8811acf94a21fc04f35e89cd4f72ce97.png";